import React, { Suspense, useRef, useEffect, useState } from "react";
import * as THREE from "three";
import { Canvas, useFrame } from "@react-three/fiber";
import { OrbitControls, useGLTF } from "@react-three/drei";

function BeeScout({ scrollProgress = 0 }) {
    const group = useRef();
    const mixer = useRef();
    const { scene, animations } = useGLTF("/images/demon_bee_full_texture.glb");

    useEffect(() => {
        if (!animations || animations.length === 0) return;

        mixer.current = new THREE.AnimationMixer(scene);

        animations.forEach((clip) => {
            const action = mixer.current.clipAction(clip);
            action.play();
        });

        return () => {
            if (mixer.current) mixer.current.stopAllAction();
        };
    }, [animations, scene]);

    useFrame((state, delta) => {
        if (mixer.current) mixer.current.update(delta);

        if (!group.current) return;
        const t = state.clock.getElapsedTime();

        group.current.position.x = Math.sin(t * 0.6) * 1.2;

        // NOUVEAU : descend de -15vh (énorme amplitude)
        group.current.position.y = -1.5 + Math.sin(t * 1.2) * 1.5; // de -3 à 0

        group.current.position.z = Math.cos(t * 0.6) * 1.2;

        group.current.rotation.y = Math.sin(t * 0.4) + scrollProgress * 0.6;
        group.current.rotation.x = 0.15 + scrollProgress * 0.2;
    });

    return (
        <group ref={group} scale={1.75}>
            <primitive object={scene} />
        </group>
    );
}

const AbonnementScene3D = ({ scrollProgress = 0 }) => {
    const [enabled, setEnabled] = useState(() => {
        if (typeof window === "undefined" || !window.matchMedia) return true;
        return !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    });

    useEffect(() => {
        if (!window.matchMedia) return undefined;

        const media = window.matchMedia("(prefers-reduced-motion: reduce)");
        const onChange = () => setEnabled(!media.matches);
        onChange();

        if (media.addEventListener) media.addEventListener("change", onChange);
        else media.addListener(onChange);

        return () => {
            if (media.removeEventListener) media.removeEventListener("change", onChange);
            else media.removeListener(onChange);
        };
    }, []);

    if (!enabled) return null;

    return (
        <div className="scene3d-overlay" aria-hidden="true">
            <Canvas camera={{ position: [0, 1.1, 4], fov: 45 }} dpr={[1, 2]}>
                <ambientLight intensity={0.6} />
                <directionalLight intensity={1.2} position={[2, 3, 2]} color="#ff33cc" />
                <directionalLight intensity={0.9} position={[-2, 1.5, -2]} color="#00ffff" />

                <Suspense fallback={null}>
                    <BeeScout scrollProgress={scrollProgress} />
                    <mesh position={[0, -0.4, 0]} rotation={[-Math.PI / 2, 0, 0]}>
                        <planeGeometry args={[4, 4]} />
                        <meshStandardMaterial
                            color="#050012"
                            emissive="#00ffff"
                            emissiveIntensity={0.4}
                            opacity={0.0} // on peut même le rendre invisible
                            transparent
                        />
                    </mesh>
                </Suspense>

                <OrbitControls enableZoom={false} enablePan={false} enableRotate={false} />
            </Canvas>
        </div>
    );
};


export default AbonnementScene3D;
